import axios from "axios";

const initialState = {
    investorArticle: {
        article_id: "",
        slug: "",
        title:"",
        abstract: "",
        content: "",
        json: {},
        html: "",
        created: ""
    },
    investorArticles: [],
    investorArticlesCount: 0,
    queryObject: {
        offset: 0,
        limit: 5,
    },
};

export const state = { ...initialState };

export const actions = {
    async loadInvestorArticles(context) {
        return axios.get("/api/investor/articles", {params: context.state.queryObject}).then(function(response){
            console.log(response)
            context.commit("setInvestorArticles",response.data.investorArticles);
            context.commit("setInvestorArticlesCount",response.data.investorArticlesCount);
        });
    },
    async loadInvestorArticle(context, slug) {
        return axios.get('/api/investor/article',{
            params: {
                slug: slug
            }
        }).then(function(response){
            console.log(response.data)
            context.commit("articleSet",response.data);
        })
    },

    updateQuery(context,data){
        context.commit("setQuery",data);
    },
}

export const mutations = {
    articleClear(state) {
        state.investorArticle = {
            article_id: "",
            slug: "",
            title:"",
            abstract: "",
            content: "",
            json: {},
            html: "",
            creation: ""
        };
    },
    setQuery(state,obj){
        state.queryObject=obj;
    },
    articleSet(state, article) {
        state.investorArticle = article;
    },
    setInvestorArticlesCount(state, count) {
        state.investorArticlesCount = count;
    },
    setInvestorArticles(state, articles) {
        state.investorArticles = articles;
    }
}

const getters = {
    investorArticle(state) {
        return state.investorArticle;
    },
    investorArticles(state) {
        return state.investorArticles;
    },
    investorArticlesCount(state) {
        return state.investorArticlesCount;
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};
